import request from "@/utils/request";

export function getList(params) {
  return request({
    url: "/HostelList/GetGroupWithPaging",
    method: "get",
    params,
  });
}
export function getInfo(params) {
  return request({
    url: "/HostelList/GetStudentInfo",
    method: "get",
    params,
  });
}
export function getStuInfo(params) {
  return request({
    url: "/HostelList/GetStudentInfo",
    method: "get",
    params,
  });
}
export function checkOut(data) {
  return request({
    url: "/HostelList/CheckOut",
    method: "post",
    data,
  });
}
export function checkIn(data) {
  return request({
    url: "/HostelList/CheckIn",
    method: "post",
    data,
  });
}
export function saveAdjustment(data) {
  return request({
    url: "/HostelList/SaveRoomAdjustment",
    method: "post",
    data,
  });
}
export function getRoomColor(params) {
  return request({
    url: "/HostelList/GetRoomTypeColorGroup",
    method: "get",
    params,
  });
}
export function getBedColor(params) {
  return request({
    url: "/HostelList/GetBedStateColorGroup",
    method: "get",
    params,
  });
}
export function getPersonColor(params) {
  return request({
    url: "/HostelList/GetStudentSpecialTypeColorGroup",
    method: "get",
    params,
  });
}
export function swapBed(data) {
  return request({
    url: "/HostelList/SwapBed",
    method: "post",
    data,
  });
}
export function batchCheckIn(data) {
  return request({
    url: "/HostelList/BatchCheckIn",
    method: "post",
    data,
  });
}
export function batchCheckOut(data) {
  return request({
    url: "/HostelList/BatchCheckOut",
    method: "post",
    data,
  });
}
export function batchSetBedTags(data) {
  return request({
    url: "/HostelList/BatchSetBedTags",
    method: "post",
    data,
  });
}
